<style scoped lang="scss">
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
.search-box{
  overflow: hidden;
  display: flex;
  padding: 0 0 0 10px;
  border: 1px solid #014492;
  align-items: center;
}
.btn_high{
  background: #014492;
  color: #fff;
  border: none;
  outline-style:none;
  height: 42px;
  border-radius: 0;
}
input{
  background: #F9F9F9;
  height:30px;
  line-height: 30px;
  padding:0 10px;
  border-radius: 4px 0 0 4px;
  border:1px solid #ddd;
  border-right: 0;
  width: 100px;
}
.btn-search{
  height:30px;
  background: #014492;
  img{
    height: 30px;
  }
}
.main-content{  
    display: flex;
    width: 1200px;
    margin: 0 auto;
    justify-content: space-between;
    .nav{
      width: 180px;
      border:1px solid #E4E6EA;
      height: 400px;     
      .title{
        border-bottom:1px solid #E4E6EA;
         padding-left: 30px;
         font-size: 20px;
         padding-top: 10px;
         padding-bottom: 10px;         
      }
      ul{
        height: 350px;
        padding-top: 10px;
         overflow-y: auto;
         padding-bottom: 10px;
      }
      ul li{
        padding-left: 30px;
         font-size: 16px;
         line-height: 1.3;
         cursor: pointer;
         padding: 8px 10px 8px 30px;;
      }
      ul li:hover{
        text-decoration: underline;
      }
      ul li.on{
        color:#389dff;
      }
    }
    .container2{
      width: 1000px;
    }
}
</style>
<style scoped>
@import url("../../assets/service.css");
@media screen and (max-width: 641px){
  .wrap-summary .breads{
    display: none!important;
  }
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .search-result,.search-box{
    margin-left: 10px;
    margin-right: 10px;
  }
  .download li{
    padding: 20px 5px!important;
  }
}
@media screen and (max-width: 640px){
  .main-content{
    width: 100%;
    display: block;
    
  }
  .main-content .nav{
      height: auto;
      width: 100%;
      margin-bottom: 10px;
      border-left: 0;
      border-right: 0;
    }
    .main-content .nav .title{
      display: none;
    }
    .main-content .nav ul{
      height: auto;
    }
    .main-content .nav ul li{
      display: inline-block;
      width: 33%;
      vertical-align: top;
      height: 30px;
      overflow: hidden;
    }
  .container2{
    width: 100% !important;
    font-size: 12px!important;
  }
  .mr42{
    display: block!important;
  }
  .mr41{
    display: none!important;
  }
  .download li{
    width: 90% !important;
    margin-left: 10px;
    font-size: 14px!important;
    margin-bottom: 20px;
  }
  .download li:last-child{
    margin-bottom: 0;
  }
  .el-button{
    margin-left: 10px;
  }
  .download{
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    display: block!important;
  }
}
</style>
<style>
.input .el-input__inner{
  border: none!important;
}
</style>
<template>
  <div class="wrap wrap-summary">   
    <div class="banner">
      <img src="@/assets/img/resource.png" class="img-fluid" alt="擎科生物资源中心">
      <!-- <qk-top-tabs :menuLists="menuLists" @getLists="(id)=>{getResourcesLists(id,'tabChange');}"/> -->
        <qk-top-tabs ref="tabs" :menuLists="menuLists" @getLists="clickMenuList"/>
    </div>    
<!--    <router-view></router-view>-->
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;margin-top: 20px;">
      <bread></bread>
    </div>
    <div class="main-content mt30">
      <div class="nav" v-if="classfyFlag&&this.categoryId !== 3">
         <div class="title">分类</div>
         <ul>
          <li :class="classificationId==item.id?'on':''" 
          v-for="(item,index) in leftMenuLists" 
          :key="index"
          @click="clickLeftMenuLists(item)">
          {{item.name}}
          </li>         
         </ul>
      </div>
      <div class="right-content">
          <div class="container2 mb30" :style="getRightWidth()"><!--    style="width:1200px"-->
            <ul class="download" v-if="this.categoryId != 3">  <!--v-if="this.categoryId === 1 || this.categoryId === 2"-->
              <li v-for="item in resourcesLists" :key="item.id" >
                {{item.name}}
                <!-- {{item.resourceFile.fileType}} -->
                <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
                <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

                <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
                <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
              </li>
            </ul>
            <div class="search-box" v-if="this.categoryId === 3">
              <label style="width: 63px;">关键词：</label>
              <div class="input" style="width: 100%;">
                <!--请输入关键字搜索-->
                <el-input
                  placeholder="search by service/product name ,catalog no,other keywords"
                  v-model="search"
                  style="border:none;outline-style: none;"
                  clearable>
                </el-input>
              </div>
              <el-button @click="bindSearch" class="btn_high">搜索</el-button>
            </div>
            <el-row v-if="this.categoryId === 3">
              <el-col :span="24">
                <div class="search-result">
                  <el-table
                  :data="allLists"
                  border
                  style="width: 100%;margin-top: 30px;">
                  <el-table-column
                    prop="name"
                    label="项目名称"
                    align="center">
                  </el-table-column>
                  <el-table-column
                    prop="periodical"
                    label="期刊"
                    align="center">
                  </el-table-column>
                  <el-table-column
                    prop="factor"
                    align="center"
                    label="影响因子">
                  </el-table-column>
                  <el-table-column
                    prop="goods"
                    align="center"
                    label="擎科产品/服务">
                  </el-table-column>
                  <el-table-column
                    prop="number"
                    align="center"
                    label="产品货号">
                </el-table-column>
                  <el-table-column
                      prop="url"
                      align="center"
                      label="文章链接">
                    <template slot-scope="scope">
                      <el-button @click="handleClick(scope.row.url)" type="text" size="small"><a :href="scope.row.url">link</a></el-button>
                    </template>
                  </el-table-column>
                  </el-table>
                  <div class="page" >
                    <el-pagination
                      background
                      layout="prev, pager, next"
                      :total="total1"
                      :page-size="10"
                      :pager-count="7"
                      @size-change="changeSize"
                      @current-change="changePage1">
                    </el-pagination>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="no-data" v-show="resourcesLists.length === 0" v-if="this.categoryId !== 3">暂无数据</div>
          <div class="page" v-show="total > 20" v-if="this.categoryId !== 3"> <!-- v-if="this.categoryId ===1 || this.categoryId === 2" -->
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="20"
              :total="total"
              :current-page="page+1"
              @current-change="changePage">
            </el-pagination>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { resourceColumns, resourceDownloads,searchLiterature,classifications, sangerDownlodFile } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  name: "resource",
  components:{
    bread,
  },
  data () {
    return {
      menuLists: [],
      leftMenuLists:[],
      page: 0,
      page1: 0,
      size:0,
      total: 0,
      total1: 0,
      resourcesLists: [],
      categoryId: '',
      goodsLists:[],
      resId: '',
      keywords: '',
      allLists: [],
      resultLists: [],
      search: '',
      classfyFlag:false,
      classificationId:'-1'
    }
  },
  async created () {
    // console.log("created",this.$route)
    await this.getResourceColumns();
    if(this.$route.params.id){
      this.$nextTick(()=>{
        if(this.$refs.tabs){
          this.$refs.tabs.getLists(this.$route.params.id,this.$route.params.index)
        }
        
      })
    }
    
  },
  mounted () {
    eventBus.$on('changeResourceTab', (vals) =>{
      this.$nextTick(()=>{
        if(this.$refs.tabs){
          this.$refs.tabs.getLists(vals.id,vals.index)
        }
      })
    })
  },
  watch: {
    $route (to) {
      this.page1 = 0
      this.bindSearch()
      
    }
  }, 
  methods: {
    clickMenuList(id){      
      console.log("clickMenuList",id)
      this.resourcesLists=[];
      this.categoryId = id;
      this.classificationId="-1";      
      this.page=0
      this.getClassifications();            
    },
    clickLeftMenuLists(row){
      this.classificationId=row.id;
      this.getResourcesLists(this.categoryId,'tabChange');      
      this.page=0
    },
    getRightWidth(){
       return (this.classfyFlag&&this.categoryId !== 3)?'width:1000px':'width:1200px'
    },    
    handleClick(row) {
      // let href = "http://8.130.53.158/";
      window.open(row, "_blank");
    },
    // 查询搜索结果
    bindSearch () {
      searchLiterature(this.search,this.page1,10).then(res => {
          this.allLists = res.data.list
          this.total1 = res.data.totalCount
        })
    },
    // 资源栏目
    async getResourceColumns () {
      await resourceColumns().then(res => {
        console.log("getResourceColumns",res.data)
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.categoryId = res.data[0].id;
        this.getClassifications();    
      })
    },
    //资源分类
    getClassifications(){      
      let params={
          columnId:this.categoryId,        
      }
      classifications(params).then(res=>{
        let firstMenu={
          id:'-1',
          name:"全部",          
        }
        this.leftMenuLists=[firstMenu,...res.data];

        if(res.data.length){
          this.classfyFlag=true;
          // this.classificationId=res.data[0].id;
          this.getResourcesLists(this.categoryId,'tabChange');
        }else{
          this.classfyFlag=false;
          this.classificationId="-1";
          // this.page=0
          this.getResourcesLists(this.categoryId,'tabChange');
        }
        
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id,checkType) {
      // this.categoryId = id
      if(checkType == 'tabChange'){
        this.page = 0
        this.page1 = 0
      }
      if(id != 3){
        
        // resourceDownloads(id, this.page, 20,this.classificationId).then(res => {
        //   this.resourcesLists = res.data
        //   this.total = this.baseMethods.getTotal(res)
        // })
       
        let params={ 
          'resourceCenterId.equals': id,
          // 'classificationId.equals': this.classificationId,
          page: this.page,
          size: 20}
        if(this.classificationId!='-1'){
             params['classificationId.equals']=this.classificationId
        }
        resourceDownloads(params).then(res => {
          this.resourcesLists = res.data
          this.total = this.baseMethods.getTotal(res)
        })
      }else{
          this.bindSearch();
      }
      
      //this.bindSearch();
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      if(item.resourceFile.name == '擎科生物测序样本登记单'){
        let memberInfo = this.baseMethods.getLocalObj('memberInfo')
        sangerDownlodFile({customerId: memberInfo.id||'' }).then((res)=>{
          let link = document.createElement("a");
          let body = document.querySelector("body");
          link.href = window.URL.createObjectURL(res.data);
          link.download = "擎科生物测序样本登记单.xlsx";
          link.style.display = "none";
          body.appendChild(link);
          link.click();
          body.removeChild(link);
          window.URL.revokeObjectURL(link.href);
        })
      }else{
        this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
      }
      
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },
    changeSize (value) {
      this.size = value
      this.bindSearch()
    },
    changePage1 (value) {
      this.page1 = value - 1
      this.bindSearch()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/resource/index.vue